import { attentionColor, truewhite } from 'src/styles/colors'
import { fontWeightBold } from 'src/styles/font'
import { FREE_COMPANY_ALERT_URL } from 'src/utils/routes'
import styled from 'styled-components'
import { AlertBannerCss } from './common'

export const FreeCompanyAlertBanner = () => (
  <FreeCompanyAlertDiv>
    <p>
      プラットフォーム健全化のため、４つのルールを必ずお守り下さい。
      <br />
      上記行為が発覚した場合、アカウント停止等の対応をさせて頂きます。
      <FreeCompanyAlertLinkTag href={FREE_COMPANY_ALERT_URL} target="_blank">
        詳細はこちら
      </FreeCompanyAlertLinkTag>
    </p>
  </FreeCompanyAlertDiv>
)

const FreeCompanyAlertDiv = styled.div`
  ${AlertBannerCss}
  background-color: ${attentionColor};
  color: ${truewhite};
  text-align: center;

  @media screen and (max-width: 960px) {
    display: none;
  }
`
const FreeCompanyAlertLinkTag = styled.a`
  font-weight: ${fontWeightBold};
  text-decoration: underline;
`
